
import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";


function Appointments() {
  const navigate = useNavigate();
  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/jquery-ui/jquery-ui.min.js',
      'assets/vendor/jquery-ui/custom.js',
      'assets/vendor/calendar/custom/appointments-calendar.js',
      'assets/vendor/calendar/js/main.min.js',
      //'assets/vendor/apex/apexcharts.min.js',
      //'assets/vendor/apex/custom/home/patients.js',
      //'assets/vendor/apex/custom/home/department-income.js',
      //'assets/vendor/apex/custom/home/income.js',
      //'assets/vendor/apex/custom/home/appointments-overview.js',
      //'assets/vendor/apex/custom/home/sparklines.js',
      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);
  const handleSubmit = () => {
    // Optional: Add form validation logic here
    navigate("/book-appointment");
    setTimeout(() => {
      window.location.reload(); // force page refresh after navigation
    }, 100);
  }
  return (
    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index-2.html">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item">Appointments</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Appointments
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        <div className="ms-auto d-lg-flex d-none flex-row">
          <div className="input-group">
            <span className="input-group-text bg-primary-lighten">
              <i className="ri-calendar-2-line text-primary" />
            </span>
            <input type="text" id="abc" className="form-control custom-daterange" />
          </div>
        </div>
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-sm-12 col-12">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h5 className="card-title">Applointments</h5>
                <button
                              type="button"
                              className="btn btn-primary my-4"
                              onClick={handleSubmit}
                            >
                              Book Appointment
                            </button>
              </div>

              <div className="card-body">
                <div>
                  <div id="appointmentsCal"></div>
                </div>
                <div id="appointmentsCal" />



              </div>

            </div>

          </div>
        </div>
        {/* Row ends */}

      </div>


      {/* App body ends */}
    </div>
  )
}
export default Appointments;